import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.js';

// Client half of the curated content bank read path — see
// functions/contentBank.js for the full design (why it's separate from
// askAI, the Firestore layout, the access model). Called from
// src/lib/askAI.js's attachAskAIBridge relay, same as askAIInPage/
// askAIContentInPage are — never called directly by a generated page,
// which has no Firebase session of its own.
const fetchContentBankItemsFn = httpsCallable(functions, 'fetchContentBankItems');

export async function fetchContentBankItems({
  ownerUid, courseId, topicId, count,
}) {
  const { data } = await fetchContentBankItemsFn({
    ownerUid, courseId, topicId, count,
  });
  return data.items;
}
